import { BoolFilter, SingleSelectSimpleFilter } from "@dash/filters";
import { SearchBox } from "@dash/search";

export type CartsFilterValues = {
  isArchived?: boolean;
  isFulfilled?: boolean;
  hasRewards?: boolean;
  excludeEmpty?: boolean;
  searchTerm?: string;
};

type Props = {
  values: CartsFilterValues;
  onChange: (patch: Partial<CartsFilterValues>) => void;
  className?: string;
};

type ArchiveFilterOption = "active" | "archived" | "completed";

const valuesToArchiveFilter = (values: CartsFilterValues): ArchiveFilterOption | undefined => {
  if (values.isFulfilled === true) return "completed";
  if (values.isArchived === true) return "archived";
  if (values.isArchived === false) return "active";
  return undefined;
};

const applyArchiveFilterOption = (
  v: ArchiveFilterOption | undefined,
): Pick<CartsFilterValues, "isArchived" | "isFulfilled"> => {
  if (v === undefined) return { isArchived: undefined, isFulfilled: undefined };
  if (v === "active") return { isArchived: false, isFulfilled: undefined };
  if (v === "archived") return { isArchived: true, isFulfilled: undefined };
  return { isArchived: undefined, isFulfilled: true };
};

export const CartsFilters: React.FC<Props> = ({ values, onChange, className }) => {
  return (
    <div className={className} css={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", alignItems: "center" }}>
      <SearchBox
        value={values.searchTerm ?? ""}
        onChange={(value) => onChange({ searchTerm: value })}
      />
      <SingleSelectSimpleFilter<ArchiveFilterOption>
        label="Archiwum"
        value={valuesToArchiveFilter(values)}
        options={[
          { label: "Aktywny", value: "active" },
          { label: "Zarchiwizowany", value: "archived" },
          { label: "Zrealizowany", value: "completed" },
        ]}
        onChange={(v) => onChange(applyArchiveFilterOption(v))}
      />
      <BoolFilter
        label="Z nagrodami"
        value={values.hasRewards}
        onChange={(v) => onChange({ hasRewards: v })}
        falseLabel="Nie"
        trueLabel="Tak"
      />
      <BoolFilter
        label="Ukryj puste"
        value={values.excludeEmpty}
        onChange={(v) => onChange({ excludeEmpty: v })}
        falseLabel="Nie"
        trueLabel="Tak"
      />
    </div>
  );
};
